import "./Heading.css";

const Heading = () => {
    return (
        <div className="heading-article">
        </div>
    )
}

export default Heading;